<template>
    <div class="w-full">
        <div v-if="showPins" class="relative">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" :width="w" :height="h">
                <circle v-for="(pin, index) in pins1" :key="index" :cx="pinPositions[index].cx"
                    :cy="pinPositions[index].cy" :r="radius" stroke="black" stroke-width="1" :fill="pinColors[index]"
                    @click="resetState(index)" />
                <polygon :points="pin1ReplayPoints" class="cursor-pointer transition-colors hover:opacity-80"
                    style="fill:lime;stroke:purple;stroke-width:1" v-if="displayPinReplayTag" @click="openReplay" />
                <polygon :points="pin2ReplayPoints" class="cursor-pointer transition-colors hover:opacity-80"
                    style="fill:lime;stroke:purple;stroke-width:1" v-if="displayBowlerReplayTag"
                    @click="openBowlerReplay" />
            </svg>
        </div>
    </div>
</template>

<script setup>
import { computed, ref, onMounted } from 'vue';
import jsUtil from "@/global/jsUtil";

const props = defineProps({
    pins1: {
        type: Array,
        required: true,
        default: () => Array(10).fill(true) // 默认值为一个包含10个true的数组
    },
    pins2: {
        type: Array,
        default: () => Array(10).fill(true) // 默认值为一个包含10个false的数组
    },
    w: {
        type: String,
        required: true
    },
    h: {
        type: String,
        required: true
    },
    enableSetPin: {
        type: Boolean,
        default: true
    },
    showReplay: {
        type: Boolean,
        default: false
    },
    pinReplayUrl: {
        type: String,
        default: ''
    },
    bowlerReplayUrl: {
        type: String,
        default: ''
    },
    radius: {
        type: Number,
        default: 2.75
    }
});

const emit = defineEmits(['pins-changed']);
const pinPositions = ref([
    { cx: '50%', cy: '86.7%' },
    { cx: '38%', cy: '63%' },
    { cx: '62%', cy: '63%' },
    { cx: '25%', cy: '40%' },
    { cx: '50%', cy: '40%' },
    { cx: '75%', cy: '40%' },
    { cx: '12%', cy: '16.7%' },
    { cx: '38%', cy: '16.7%' },
    { cx: '62%', cy: '16.7%' },
    { cx: '88%', cy: '16.7%' }
]);

const pinColors = computed(() => {
    return props.pins1.map((pin, index) => {
        if (!pin) {
            return 'green'; // 一球打到
        } else if (props.pins2 && !props.pins2[index]) {
            return 'blue'; // 二球打到
        } else {
            return 'white'; // 没有打到或二球没打到
        }
    });
});

const showPins = computed(() => {
    return jsUtil.hasValue(props.pins1) && props.pins1.length === 10;
});

const pin1ReplayPoints = computed(() => "10,100 10,120 25,110");
const pin2ReplayPoints = computed(() => "105,100 105,120 120,110");

const displayPinReplayTag = computed(() => {
    return props.showReplay && !jsUtil.isBlank(props.pinReplayUrl);
});

const displayBowlerReplayTag = computed(() => {
    return props.showReplay && !jsUtil.isBlank(props.bowlerReplayUrl);
});

const resetState = (index) => {
    if (props.enableSetPin && props.pins1) {
        props.pins1[index] = !props.pins1[index];
        emit('pins-changed', props.pins1);
    }
};

const openReplay = () => {
    if (!jsUtil.isBlank(props.pinReplayUrl)) {
        window.open(props.pinReplayUrl, "_blank");
    }
};

const openBowlerReplay = () => {
    if (!jsUtil.isBlank(props.bowlerReplayUrl)) {
        window.open(props.bowlerReplayUrl, "_blank");
    }
};

onMounted(() => {
    // 可以在这里初始化一些数据或逻辑
});
</script>

<style scoped>
/* SVG 交互样式 */
circle {
    @apply cursor-pointer transition-colors;
}

circle:hover {
    @apply opacity-80;
}

/* 保持 SVG 响应式 */
svg {
    @apply w-full h-full;
}
</style>